module.exports = __webpack_public_path__ + "static/media/ic-chevron-right.6207546e.svg";